import type { RequirementColumn } from "./type";
import { QuotationRequestItem } from "@/types/quotationRequestItem";
import {
  QuotationRequest,
  RequirementConfirm,
  RequirementConfirmShowEnum,
  RequirementConfirmTypeEnum,
  RequirementConfirmValueEnum,
  RequirementItem,
} from "@/types/requirement";
import { divided, multi } from "@/utils/calc";

export function requirementIsEnd(items: RequirementConfirm[]): boolean {
  let flag = true;
  for (let i = 0; i < items.length; i++) {
    if (items[i].show === RequirementConfirmShowEnum.SHOW && items[i].value !== RequirementConfirmValueEnum.PASSED) {
      flag = false;
      break;
    }
  }
  return flag
}

export function getRequirementConfirmItem(
  items: RequirementConfirm[],
  type: RequirementConfirmTypeEnum,
  direction: "next" | "prev",
  desc: string
): Array<RequirementConfirm> {
  const visibleItems = items
    .filter((item) => item.show !== RequirementConfirmShowEnum.HIDDEN)
    .sort((a, b) => a.sort - b.sort);

  const currentIndex = visibleItems.findIndex((item) => item.type === type);

  if (currentIndex === -1) {
    return items;
  }

  if (direction === "next") {
    const nextData = visibleItems[currentIndex + 1];
    if (!nextData) {
      return items.map((item) => ({
        ...item,
        value:
          item.type === type
            ? RequirementConfirmValueEnum.PASSED
            : item.show === RequirementConfirmShowEnum.HIDDEN
              ? RequirementConfirmValueEnum.PASSED
              : item.value,
        desc: item.type === type ? desc : item.desc,
      }));
    }
    return items.map((item) => {
      let value = item.show === RequirementConfirmShowEnum.HIDDEN ? RequirementConfirmValueEnum.PASSED : item.value;
      if (item.type === type) {
        value = RequirementConfirmValueEnum.PASSED;
      }
      if (nextData.type === item.type) {
        value = RequirementConfirmValueEnum.NOT_PASS;
      }
      return {
        type: item.type,
        sort: item.sort,
        show: item.show,
        desc: item.type === type ? desc : item.desc,
        value,
      };
    });
  } else if (direction === "prev") {
    const prevData = visibleItems[currentIndex - 1];
    if (!prevData) {
      return items.map((item) => ({
        ...item,
        value:
          item.type === type
            ? RequirementConfirmValueEnum.NOT_PASS
            : item.show === RequirementConfirmShowEnum.HIDDEN ? RequirementConfirmValueEnum.PASSED : item.value,
        desc,
      }));
    }
    return items.map((item) => {
      let value = item.show === RequirementConfirmShowEnum.HIDDEN ? RequirementConfirmValueEnum.PASSED : item.value;
      if (item.type === type) {
        value = null;
      }
      if (prevData.type === item.type) {
        value = RequirementConfirmValueEnum.REJECTED;
      }
      return {
        type: item.type,
        sort: item.sort,
        show: item.show,
        desc: item.type === type ? desc : item.desc,
        value,
      };
    });
  }

  return items;
}

export const getTruePrice = (record: QuotationRequestItem | QuotationRequest) => {
  if (!record.supplierPrice) return null
  else {
    let truePrice: number = 0;
    if (!!record.mpq) {
      truePrice = Math.ceil(Number(record.count) / Number(record.mpq)) * Number(record.mpq) * Number(record.supplierPrice)
    } else truePrice = Number(record.count) * Number(record.supplierPrice)
    return truePrice;
  }
}

export const getQuotationRequestTruePrice = (record: QuotationRequest) => {
  if (!record) return 0
  else {
    let truePrice: number = 0;
    if (record.mpq) {
      truePrice = Math.ceil(Number(record.count) / Number(record.mpq)) * Number(record.mpq) * Number(record.supplierPrice)
    } else truePrice = Number(record.count) * Number(record.supplierPrice)

    return truePrice;
  }
}

export const getQuotationPrice = (
  record?: Pick<QuotationRequestItem | QuotationRequest, "supplierPrice"> | null
) => {
  if (!record?.supplierPrice) return null;

  const priceNumber = Number(record.supplierPrice);
  return Number.isFinite(priceNumber) ? priceNumber : null;
}

export const numFormmater = (num: number, p = 5) => {
  const formmater = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: p
  });
  let res = formmater.format(num)
  return res;
}


export const getTrueCount = (count: string, mpq: string) => {
  let ceil = Math.ceil(Number(divided(count, mpq)))
  return multi(ceil + '', mpq)
}

// 同一物料可能来自不同 BOM 项或替代关系，不能只以 product.id 作为行键。
export const getRequirementRowKey = (item: RequirementColumn) => JSON.stringify([
  item.bomProcess, item.bomIndex, item.bomItemId, item.bomReplId, item.replaceParentId, item.product.id,
]);
